//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import ErrorLogger from "./ErrorLogger";
import GoToNextPageActionHandler from "./actionsHandlers/GoToNextPageActionHandler.js";
import CallCallbackActionHandler from "./actionsHandlers/CallCallbackActionHandler.js";
class ActionsManager {
  constructor(store, handlerExtention = {}) {
    this.store = store;

    this.handlers = {
      GoToNextPageActionHandler,
      CallCallbackActionHandler,
      ...handlerExtention,
    };

    this.executedInstructionActionsIds = [];
    this.lastInstructionActionId = null;
    this.lastInstructionActionIdCount = 0;
    this.verificationVue = null;
    this.isStopped = false;
    this.canTakePictures = true;
    this.canShowInstructionAlert = false;
    this.appPaused = false;
  }

  async addActions(actions, shouldWait = true) {
    let handlerType;
    if (actions && actions.length > 0) {
      for (const action of actions) {
        handlerType = action.type + "Handler";
        if (handlerType in this.handlers) {
          const handler = new this.handlers[handlerType](this);
          try {
            await handler.handle(action, this.store, shouldWait);
          } catch (error) {
            ErrorLogger.log(
              "Exception in " + handlerType + "with error:  " + error,
              "WEBVIEW_ACTIONS"
            );
          }
        }
      }
    }
  }

  setCanTakePictures(canUse) {
    this.canTakePictures = canUse;
  }

  canShowInstructionAlertPage() {
    return this.canShowInstructionAlert;
  }

  setCanShowInstructionAlert(status) {
    this.canShowInstructionAlert = status;
  }

  canTakePicture() {
    return this.canTakePictures;
  }

  setAppPaused(isPaused) {
    this.appPaused = isPaused;
  }

  isAppPaused() {
    return this.appPaused;
  }

  getExecutedInstructionActionsIds() {
    return this.executedInstructionActionsIds;
  }

  stop() {
    this.isStopped = true;
    this.cancelCameraOpening();
  }

  resume() {
    this.isStopped = false;
  }

  updateLastActionId(id) {
    this.executedInstructionActionsIds.push(id);
    if (this.lastInstructionActionId == id) {
      this.lastInstructionActionIdCount += 1;
    } else {
      this.lastInstructionActionIdCount = 0;
    }
    this.lastInstructionActionId = id;
  }

  getLastActionId() {
    return this.lastInstructionActionId;
  }

  getLastActionIdCount() {
    return this.lastInstructionActionIdCount;
  }
}

export default ActionsManager;
